import actions from '@/core/store/item-ata/alterar-fornecedor/historico/actions'
import state from '@/core/store/item-ata/alterar-fornecedor/historico/state'
import mutations from '@/core/store/item-ata/alterar-fornecedor/historico/mutations'

export default { actions, state, mutations }
